export default "__VITE_ASSET__Dtm$FVXn__"